import { render, staticRenderFns } from "./StatusDisplay.vue?vue&type=template&id=2983cf6d"
import script from "./StatusDisplay.vue?vue&type=script&lang=ts"
export * from "./StatusDisplay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports